export const isBetween = (x, a, b) => {
  let min = Math.min(a, b);
  let max = Math.max(a, b);

  return x >= min && x <= max;
};
